import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { getImageProps } from 'app/utilities/ImageProps';
import { gtag4, switchExtraction } from '../../../utilities/analytics/tracking';
import { reportDWH } from './salePackagesBlockSlice';
import SalePackages from './SalePackages';
import Tabs from './Tabs';
import { fetchPackagePopularMarket } from '../CellcomAbroadLobbyBlock/Shared/abroadThunk';
import { prepareSameWindowUrlWithNavigateTo } from '../../../utilities/StringHelpers/StringHelpers';

const SalePackagesWrapper = (props) => {
  const activeSalePackagesTab = props?.iContent?.tabs?.value == null ? '' : props?.iContent?.tabs?.expandedValue[0] //data from EPI of first Package
  const [priTitle, setPriTitle] = useState(activeSalePackagesTab?.title?.value);
  const [subTitle, setSubTitle] = useState(activeSalePackagesTab?.subTitle?.value);
  const [textTab, setTextTab] = useState(activeSalePackagesTab?.buttonText?.value);
  const [index, setIndex] = useState(0);
  const isFilterByInfrastructure = !!props.iContent.isFilterByInfrastructure?.value;

  // data for EPI
  const tabs = props?.iContent?.tabs?.expandedValue?.map((item) => {
    const textTab = item?.buttonText?.value;
    const title = item?.title?.value;
    const subTitle = item?.subTitle?.value;
    const salePackages = item?.salePackages.expandedValue;
    const lobbyFolderReference = item?.lobbyFolderReference;
    const isAbroadPackages = item?.lobbyFolderReference.value == null ? false : true;
    const buttonTextAllPackges = item?.buttonTextAllPackges.value;
    const linkButton = item?.linkButton?.value;
    return {
      icon: getImageProps(item.icon, props.context),
      textTab,
      title,
      subTitle,
      salePackages,
      lobbyFolderReference,
      isAbroadPackages,
      buttonTextAllPackges,
      linkButton
    };
  });

  //Choosing a package from a tab or without
  let packagesList;
  if (tabs === undefined) {
    packagesList = props?.iContent;
  }
  else {
    packagesList = tabs[index];
  }

  const abroadPackages =
    tabs
      ?.filter((item) => item.isAbroadPackages === true)
      ?.map((item) => {
        const socIdList = item.salePackages.map((item) => item?.sockCode?.value);
        const blockId = item.lobbyFolderReference?.value?.id;
        return {
          socIdList,
          blockId
        }
      });

  const abroadPackage = abroadPackages?.find(item => item.socIdList);

  const requestPackagePopular = {
    ...abroadPackage,
    clientType: 'Private'
  };

  const getBackgroundColorScreen = (item) => {
    switch (item) {
      case 0:
        return { background: 'transparent' };
      case 1:
        return { background: '#ffffff' };
      case 2:
        return { background: 'gray' };
      case 3:
        return {
          backgroundImage: 'linear-gradient(to bottom, #fff 0%, #ead6ff 100%)'
        };
      default:
        return { background: 'transparent' };
    };
  };

  const fetchDataFromMarket = async () => {
    await props.fetchPackagePopularMarket({
      SocIdList: requestPackagePopular?.socIdList,
      BlockId: requestPackagePopular?.blockId,
      ClientType: requestPackagePopular?.clientType,
      Id: props?.iContent?.contentLink?.id,
    });
  };

  useEffect(() => {
    props.reportDWH({ actionType: 'Select Offer', status: 'Ongoing', messageText: 'Offer Page Displayed' });
    //Brings information from the backend for AbroadPackages
    if (requestPackagePopular.blockId !== undefined) {
      fetchDataFromMarket();
    }
    const packages = packagesList?.salePackages?.expandedValue || packagesList?.salePackages;
  }, []);

  function onSelectedPackages(salePackage) {
    if (salePackage.link) {
      prepareSameWindowUrlWithNavigateTo(salePackage.link, props.context);
    }
    gtag4({ category: salePackage.textTab, eventType: 'CarouselPackagesSale_CategoryClick', status: 'CarouselPackagesSale' }) //Google analytic
    props.reportDWH({ actionType: 'Select Offer', status: 'Ongoing', messageText: 'Offer Button Clicked' });
  }

  return (
    <div
      className='sale-package-wrapper'
      id={props.iContent.idToScroll?.value}
      style={getBackgroundColorScreen(props.iContent.backgroundColorScreen.value)}
    >
      {tabs?.length > 1 && priTitle &&
        <h2 className='sale-package-title'>{priTitle}</h2>
      }
      <Tabs
        setPriTitle={setPriTitle}
        setSubTitle={setSubTitle}
        setTextTab={setTextTab}
        tabs={tabs}
        setIndex={setIndex}
        gtag4={gtag4}
        index={index}
      >
      </Tabs>
      {tabs?.length <= 1 && (
        <div className='wrapper-titles-tabs'>
          {priTitle && <h2 className='sale-package-title'>{priTitle}</h2>}
          {/* {subTitle && <h3 className='sale-package-subtitle'>{subTitle}</h3>} */}
        </div>
      )}
      {/* {tabs?.length > 1 && subTitle &&
        <h3 className='sale-package-subtitle'>{subTitle}</h3>
      } */}
      <SalePackages
        textTab={textTab}
        gtag4={gtag4}
        switchExtraction={switchExtraction}
        iContent={props?.iContent}
        packages={packagesList}
        onSelectedPackages={onSelectedPackages}
        context={props.context}
        infrastructure={isFilterByInfrastructure ? props.infrastructure : ''}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    infrastructure: state.checkFiberInfrastructureBlock?.addressPage?.selectedEntry?.infrastructure
  };
};

const mapDispatchToProps = {
  reportDWH,
  fetchPackagePopularMarket
};

export default connect(mapStateToProps, mapDispatchToProps)(SalePackagesWrapper);
